module.exports = __webpack_public_path__ + "static/img/IMG_20170720_004006.ff5c54e4.jpg";